const sysdenunciaConfig = {
    apiUrl: 'https://dev.portaldenuncias.trigenius.pt',
};

export default sysdenunciaConfig;